import { render, staticRenderFns } from "./user_transfer.vue?vue&type=template&id=f7860fb8&scoped=true"
import script from "./user_transfer.vue?vue&type=script&lang=js"
export * from "./user_transfer.vue?vue&type=script&lang=js"
import style0 from "./user_transfer.vue?vue&type=style&index=0&id=f7860fb8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7860fb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7860fb8')) {
      api.createRecord('f7860fb8', component.options)
    } else {
      api.reload('f7860fb8', component.options)
    }
    module.hot.accept("./user_transfer.vue?vue&type=template&id=f7860fb8&scoped=true", function () {
      api.rerender('f7860fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_market_activities/components/user_transfer.vue"
export default component.exports